import * as React from "react";
import { Box, Stack, List, ListItem, ListItemButton, Link, Typography } from "@mui/material";
import { HeaderNavProps } from "@/components/header/common/types";
import { injectSourceIntoUrl } from "@/config/unified-search-config";

type MobileTertiaryNavigationItemsProps = {
  tertiaryNavItems: HeaderNavProps[];
};
export default function MobileTertiaryNavigationItems(props: MobileTertiaryNavigationItemsProps) {
  const { tertiaryNavItems } = props;
  const navItemUrl = (url: string) => injectSourceIntoUrl(url, "mobile_nav_item");
  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: 999,
        left: 0,
        top: 0,
        width: "100%",
        height: "150%",
        backgroundColor: "background.default"
      }}
    >
      <Box
        sx={{
          pt: "70px",
          height: "85%",
          overflow: "auto"
        }}
      >
        <List
          sx={{
            paddingY: "4.6px",
            paddingTop: 0
          }}
        >
          {tertiaryNavItems.map((item) => (
            <ListItem
              sx={{
                padding: 0
              }}
              key={item.sys.id}
              data-testid={`tertiary-nav-item-${item.fields.title}`}
            >
              <ListItemButton
                sx={{
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 1,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`
                }}
              >
                <Stack
                  direction="row"
                  spacing={1.5}
                >
                  <Box sx={{
                    "&:hover": {
                      "& .MuiTypography-root": {
                        fontWeight: "600"
                      }
                    },
                    flex: 1
                  }}>
                    <Link href={navItemUrl(item.fields.url)} data-nav-level="tertiary" data-nav-label={item.fields.title} underline="none">
                      <Typography
                        sx={{
                          padding: 1,
                          fontSize: "1.4rem",
                          color: "text.secondary",
                          opacity: .8
                        }}
                      >
                        {item.fields.title}
                      </Typography>
                    </Link>
                  </Box>
                </Stack>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
}
